import { SceneState } from '../../../components/SceneStatemachinePlugin';
import { CURSOR_OVER } from 'game/constants/Constants.js';
import { BtnRoundelFramed } from '../../../display/BtnRoundelFramed';
import { HUMALONG_VO } from '../config/config';

export class StateXylophoneSongSelect extends SceneState {
  constructor(scene, songs) {
    super(scene);
    this.songs = songs;
  }

  startState() {
    this.scene.setDisplayType('select');
    this._songButtons = [];
    this._songSelected = false;

    this.songs.forEach((song, i) => this.spawnSongButton(song, i));
    this.scene.game.vo.play(HUMALONG_VO.select_song, {
      onComplete: () => this.enableButtons(),
    });
  }

  spawnSongButton(song, index) {
    const x = 600 + index * 320;
    const y = index % 2 == 1 ? 500 : 450;

    const btn = new BtnRoundelFramed(this.scene, x, y, {
      thumbSheet: 'xylophone',
      thumbKey: `btn_xylohphone_${song.id}`,
      active: !song.locked,
      hoverVO: HUMALONG_VO[song.id],
    });
    btn.locked = song.locked;
    btn.id = song.id;
    btn.once('click', () => this.handleSongSelected(btn.id), this);
    btn.setScale(0);
    this.scene.tweens.add({
      targets: btn,
      scale: 1,
      duration: 200,
      ease: Phaser.Math.Easing.Back.Out,
    });

    this._songButtons.push(btn);
  }

  enableButtons() {
    this._songButtons.forEach((b) => b.enable());
  }

  handleSongSelected(songid) {
    this._songSelected = songid;
    this._songButtons.forEach((b) => b.disable());
    const selectedbtn = this._songButtons.find((b) => b.id === this._songSelected);
    const nonselectedBtns = this._songButtons.filter((b) => {
      return b.id != songid;
    });
    this.scene.tweens.add({
      targets: nonselectedBtns,
      scale: 0,
      duration: 100,
    });
    selectedbtn.once('vocomplete', () => this.endSelection(), this);
  }

  endSelection() {
    this.scene.tweens.add({
      targets: this._songButtons.find((b) => b.id === this._songSelected),
      scale: 0,
      duration: 100,
      completeDelay: 100,
      onComplete: () => this.emit('song_select', this._songSelected),
    });
  }

  onScenePaused() {}
  onSceneResumed() {}
  onSceneUpdate(time, delta) {}
  endState() {
    if (this._songButtons) {
      this._songButtons.forEach((b) => b.destroy());
      this._songButtons = null;
    }
  }
}
